import React, {Component} from 'react'
import {createFragmentContainer, graphql} from 'react-relay'
import {compose, map} from 'ramda'
import Select from 'react-select'
import classNames from 'classnames'

import FormGroup from 'components/ui/FormGroup'
import type {Option} from 'components/proposals/types'
import {liftEdges} from 'utils/GraphQL'

const makeOption = ({currentlyHoldingElection, node: {databaseId, localizedName}}): Option => (
  {
    label: localizedName,
    value: databaseId,
    type: 'ElectRoleFiller',
    isDisabled: currentlyHoldingElection,
  }
)

const makeOptions = compose(map(makeOption), liftEdges('availableElectedRoles'))

type Props = {
  className: string,
  disabled: boolean,
  onChange: (command: string) => void,
  proposal: Object,
}

class ElectRoleFillerSelect extends Component<Props> {
  static defaultProps = {
    className: '',
  }

  onChange = (option: Option) => {
    const {value: roleDatabaseId, type} = option
    const command = JSON.stringify({roleDatabaseId, type})
    this.props.onChange(command, 'ElectRoleFiller')
  }

  get proposalDatabaseId() {
    return this.props.proposal.databaseId
  }

  get options(): Option[] {
    return makeOptions(this.props.proposal)
  }

  get className(): string {
    return classNames(this.props.className, 'refinery-select')
  }

  render() {
    return (
      <FormGroup
        // Future: provide an id so that we're not assuming a single election
        id="elect-role-filler-form"
        label={I18n.t('proposals.controls.hold_election')}
        small
      >
        <Select
          isDisabled={this.props.disabled}
          className={this.className}
          classNamePrefix="Select"
          name={`PartSelector-${this.proposalDatabaseId}-elect-role-filler-select`}
          noOptionsMessage={() => I18n.t('shared.no_results_found')}
          onChange={this.onChange}
          value={null}
          options={this.options}
          placeholder={I18n.t('proposals.rewrite.select_input_choose_role')}
        />
      </FormGroup>
    )
  }
}

export default createFragmentContainer(ElectRoleFillerSelect, {
  proposal: graphql`
    fragment ElectRoleFillerSelect_proposal on Proposal {
      databaseId
      
      availableElectedRoles: availableRoles(elected: true) {
        edges {
          currentlyHoldingElection

          node {
            databaseId
            localizedName
          }
        }
      }
    }
  `,
})
